import type { Draft } from "@reduxjs/toolkit";

export const filterOutId = (ids: number[], idToRemove: number) => ids.filter((id) => id !== idToRemove);

export const removeIdFromLookup = (
  lookup: Draft<Record<number | string, number[]>>,
  lookupId: number,
  entryIdToRemove: number,
) => {
  if (!(lookupId in lookup)) return;
  const ids = lookup[lookupId];
  const newIds = filterOutId(ids, entryIdToRemove);
  if (newIds.length === 0) {
    delete lookup[lookupId];
    return;
  }
  if (newIds.length === ids.length) return; // No change, so do nothing
  lookup[lookupId] = newIds;
};

// export const removeIdFromLookupMutating = (
//   draft: Draft<Record<number | string, number[]>>,
//   lookupId: number,
//   entryIdToRemove: number,
// ) => {
//   for (const [nodeIdStr, ids] of Object.entries(draft)) {
//     if (!ids.includes(entryIdToRemove)) continue;
//     const nodeId = Number(nodeIdStr);
//     draft[nodeId] = filterOutId(triggerIds, triggerId);
//   }
// };
